<template>
	<component
		v-if="isComponent"
		:tabIndex="tabIndex"
		:ref="getFormFieldRef()"
		:formField="formField"
		:record="record"
		:uniqueFields="uniqueFields"
		@selectedValueChanged="onSelectedValueChanged"
		:is="isComponent"
		:isBulkEdit="isBulkEdit"
		@pkFormFieldFocusChanged="onPkFormFieldFocusChanged"
	/>
</template>

<script>
const AmountField = () =>
	import('@/components/shared/fields/inventoryForm/AmountField.vue');
const ApprovalStatusField = () =>
	import('@/components/shared/fields/inventoryForm/ApprovalStatusField.vue');
const BooleanField = () =>
	import('@/components/shared/fields/inventoryForm/BooleanField.vue');
const DatetimeField = () =>
	import('@/components/shared/fields/inventoryForm/DatetimeField.vue');
const DateField = () =>
	import('@/components/shared/fields/inventoryForm/DateField.vue');
const FileField = () =>
	import('@/components/shared/fields/inventoryForm/FileField.vue');
const LinkField = () =>
	import('@/components/shared/fields/inventoryForm/LinkField.vue');
const LinkFieldMultiple = () =>
	import('@/components/shared/fields/inventoryForm/LinkFieldMultiple.vue');
const LongTextField = () =>
	import('@/components/shared/fields/inventoryForm/LongTextField.vue');
const NumberField = () =>
	import('@/components/shared/fields/inventoryForm/NumberField.vue');
const NumberDoubleField = () =>
	import('@/components/shared/fields/inventoryForm/NumberDoubleField.vue');
const PrimaryKeyField = () =>
	import('@/components/shared/fields/inventoryForm/PrimaryKeyField.vue');
const ReferenceListField = () =>
	import('@/components/shared/fields/inventoryForm/ReferenceListField.vue');
const TextField = () =>
	import('@/components/shared/fields/inventoryForm/TextField.vue');
const UserField = () =>
	import('@/components/shared/fields/inventoryForm/UserField.vue');

const AutoGeneratedFormField = () =>
	import(
		'@/components/shared/fields/inventoryForm/AutoGeneratedFormField.vue'
	);
const UnknownField = () =>
	import('@/components/shared/fields/inventoryForm/UnknownField.vue');

import { FieldDataTypes } from '../../../enums/fieldDataTypes';
import { InventoryFormFormActions } from '../../../store/actions';
import retainedValuesMixin from '../../../mixins/inventoryForm/retainedValuesMixin';
export default {
	name: 'FormField',
	mixins: [retainedValuesMixin],
	components: {
		AmountField,
		ApprovalStatusField,
		BooleanField,
		DatetimeField,
		DateField,
		FileField,
		LinkField,
		LinkFieldMultiple,
		LongTextField,
		NumberField,
		NumberDoubleField,
		PrimaryKeyField,
		ReferenceListField,
		TextField,
		UserField,
		AutoGeneratedFormField,
		UnknownField,
	},
	props: {
		formField: Object,
		record: Object,
		tabIndex: Number,
		uniqueFields: Array,
		isBulkEdit: Boolean,
	},
	computed: {
		isComponent() {
			if (!this.formField) return null;
			// if(!this.record) return null;
			if (!this.formField.GridViewFields) return null;
			if (this.formField.GridViewFields < 1) return null;

			if (this.formField.PrimaryKey) return PrimaryKeyField;

			if (this.formField.GridViewFields.length > 1)
				return LinkFieldMultiple;

			let gridViewField = this.formField.GridViewFields[0];
			if (gridViewField.LinkFieldId) return LinkField;
			if (gridViewField.ReferenceListTypeId) return ReferenceListField;

			switch (gridViewField.DataFieldType) {
				case FieldDataTypes.TEXT:
					return TextField;
				case FieldDataTypes.LONG_TEXT:
					return LongTextField;
				case FieldDataTypes.NUMBER:
					return NumberField;
				case FieldDataTypes.DOUBLE:
					return NumberDoubleField;
				case FieldDataTypes.AMOUNT:
					return AmountField;
				case FieldDataTypes.BOOLEAN:
					return BooleanField;
				case FieldDataTypes.DATETIME:
					return DatetimeField;
				case FieldDataTypes.DATE:
					return DateField;
				case FieldDataTypes.APPROVAL_STATUS:
					return ApprovalStatusField;
				case FieldDataTypes.FILE:
					return FileField;
				case FieldDataTypes.USER:
					return UserField;
				case FieldDataTypes.AUTOGENERATED_NUMBER:
				case FieldDataTypes.AUTOGENERATED_UNIQUEIDENTIFIER:
				case FieldDataTypes.AUTOGENERATED_DATETIME:
				case FieldDataTypes.AUTOGENERATED_BOOLEAN:
					return AutoGeneratedFormField;
			}

			return UnknownField;
		},
	},
	methods: {
		getFormFieldRef() {
			let ref = 'formField_' + this.formField.Id;
			return ref;
		},
		onSelectedValueChanged(param) {
			this.$emit(
				'removeFieldToCheckId',
				this.formField.GridViewFields[0].DataField.Id
			);
			if (!param) return;
			if (param.length < 1) return;
			this.$store
				.dispatch(InventoryFormFormActions.UPDATE_RECORD_KEY, param)
				.then(() => {
					this.updateRetainedValue();
				});
		},
		onPkFormFieldFocusChanged(value) {
			this.$emit('pkFormFieldFocusChanged', value);
		},
	},
};
</script>
